import { useEffect, useState } from 'react'

import { getDefaultColors } from './helpers'
import { replaceColorsByStoreThemeColors } from './helpers'

const useThemeColors = storeThemeColors => {
  const [colors, setColors] = useState(getDefaultColors())
  const [hasColorChanges, setHasColorChanges] = useState(false)

  useEffect(() => {
    if (storeThemeColors) setColors(replaceColorsByStoreThemeColors(getDefaultColors(), storeThemeColors))
  }, [storeThemeColors])

  const resetColors = () => {
    setColors(getDefaultColors())
  }

  const revertColorChanges = () => {
    setColors(replaceColorsByStoreThemeColors(getDefaultColors(), storeThemeColors))
    setHasColorChanges(false)
  }

  const changeColor = ({ value, group, type, color }) => {
    setColors(colors => ({
      ...colors,
      [group]: {
        ...colors[group],
        types: {
          ...colors[group].types,
          [type]: {
            ...colors[group].types[type],
            colors: {
              ...colors[group].types[type].colors,
              [color]: { ...colors[group].types[type].colors[color], color: value },
            },
          },
        },
      },
    }))
    setHasColorChanges(true)
  }

  return { colors, resetColors, changeColor, hasColorChanges, setHasColorChanges, revertColorChanges }
}

export default useThemeColors
